export function getHtmlDescription(data) {
    console.log(data)
    if(!data) return false
    const htmlDescriptions = data.filter(item => item && item.mimetype === 'text/html' && item.content)
    if(htmlDescriptions?.length) return htmlDescriptions

    const plainDescriptions = data.filter(item => item && (item.mimetype === 'text/plain' || item.content))
    return plainDescriptions?.length ? plainDescriptions : false
}